<app-item-base [open]="open" *ngIf="showGrossMargin">
  <p class="name" placement="right">
    粗利
  </p>

  <div class="edit-field" [ngStyle]="{'margin-left': atWorkerPage?'-1.1rem':'5.8rem'}">
    -&nbsp;<input class="form-controll-small" type="text" placeholder="万円"
      [(ngModel)]="this.searchParams.gross_margin_setting" name="gross_margin_setting" />
  </div>

</app-item-base>